<template>
  <v-flex d-flex style="flex-direction: column">
    <f-header
      :name="header || name"
    ></f-header>
    <f-row
      name="points"
      color="indigo darken-4"
      :statistics-a="statisticsA[`${name}Point`]"
      :statistics-b="statisticsB[`${name}Point`]"
      :buffer="buffer"
      height="15"
    ></f-row>
    <f-row
      name="faults"
      color="red darken-4"
      :statistics-a="statisticsA[`${name}Fault`]"
      :statistics-b="statisticsB[`${name}Fault`]"
      :buffer="buffer"
    ></f-row>
    <f-row
      name="attempts"
      color="indigo lighten-2"
      :statistics-a="statisticsA[`${name}Continue`]"
      :statistics-b="statisticsB[`${name}Continue`]"
      :buffer="buffer"
    ></f-row>
    <f-row
      name="total"
      color="black"
      :statistics-a="(statisticsA[`${name}Point`] || 0) + (statisticsA[`${name}Fault`] || 0) + (statisticsA[`${name}Continue`] || 0)"
      :statistics-b="(statisticsB[`${name}Point`] || 0) + (statisticsB[`${name}Fault`] || 0) + (statisticsB[`${name}Continue`] || 0)"
      :buffer="buffer"
    ></f-row>
  </v-flex>
</template>

<script>
import Header from './Header.vue'
import Row from './Row.vue'

export default {
  props: [
    'header',
    'name',
    'buffer',
    'statistics-a',
    'statistics-b',
  ],

  components: {
    'f-header': Header,
    'f-row': Row,
  },
}
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/StatisticsByTeam/Skill.vue